module.exports = __webpack_public_path__ + "media/static/flags/en-025c722ce79b6a4d5268cebd3ba78187.svg";